/** fileName: LocationChangeMonitor.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import React, {useEffect} from 'react';
import {SetState} from "../../redux/reduxhelper";
import {CLASS_SELECTED_DATE, IS_AUTH, PAGE_TITLE, SLIDER_INDEX} from "../../redux/action/type.action";
import {useDispatch} from "react-redux";
import {useLocation} from "react-router-dom";
import {DateObject} from "react-multi-date-picker";

const LocationChangeMonitor = ({onChange = null, children}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    let defDate = new DateObject({
        date: new Date()
    });


    // const allowedRoutes = ['/', '/account/register', '/profile'];
    // const isAuth = GetState(IS_AUTH, false)
    // const selectedBusiness = GetState(SELECTED_BUSINESS, null);
    // const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            let title = document.head.getElementsByTagName("title")[0].innerHTML ?? 'unknown';
            dispatch(SetState(PAGE_TITLE, title));
            if (onChange) onChange();
        }, 200);

        // refresh page index on reload
        dispatch(SetState(SLIDER_INDEX, 0));


        dispatch(SetState(CLASS_SELECTED_DATE, defDate.format('YYYY-MM-DD')));
        // return to home id business not selected
        // if (isAuth) {
        //     if (selectedBusiness?.id === undefined) {
        //         if (!allowedRoutes.includes(location.pathname)) {
        //             navigate('/', {replace: true});
        //             errorMessage('لطفا کسب و کار خودتان را ایجاد/انتخاب کنید')
        //         }
        //     }
        // }
    }, [location])


    return (
        <>
            {/*<ReactHelmet link={*/}
            {/*    [{"rel": "stylesheet", type:"text/css", "href": `./${themeName}`}]*/}
            {/*}/>*/}
            {children}
        </>
    );
};

export default LocationChangeMonitor;